import { AfterViewChecked, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../../environments/environment';
import { ActivatedRoute } from '@angular/router';
import { SessionStorageService } from '../../../services/session-storage.service';

@Component({
  selector: 'app-speedframe',
  templateUrl: './speedframe.component.html',
  styleUrls: ['./speedframe.component.css']
})
export class SpeedframeComponent {
  @ViewChild('testForm') testForm!: ElementRef;
  postData: string = "";
  iv: string = "";
  forms!: FormGroup;
  url: string = "";
  checkboxTimestamp: boolean = true;
  checkboxWalletron: boolean = false;
  secretKey: string = "PJbE8oRQ3Hs1sVDG2Wrjdp64U/8STtT2isvtmbGVEUU=";
  account: string = "";
  flag: boolean = true;
  original: string = '';
  ban : string ='';
  callbackComponent : String = '';

  constructor(private activatedRoute: ActivatedRoute) {
    var url = new URL(window.location.href);
    var o = url.searchParams.get("original");
    var bpno = url.searchParams.get("ban");
    var callbackurl = url.searchParams.get("callbackurl")
    if (o) this.original = o;
    if(bpno) this.ban = bpno;
    if(callbackurl) this.callbackComponent = callbackurl;


    if (window.addEventListener) {
      window.addEventListener("message", this.updateInvoicesList, true);
    }
  }

  updateInvoicesList($event: any) {
    window.removeEventListener("message", this.updateInvoicesList, true);
    var sessStorage = new SessionStorageService();
    if (typeof $event.data === 'object') {
      var invoicesData = {
        totalAmounttoPay : $event.data.totalAmounttoPay,
        invoices : $event.data.invoices,
        ban :$event.data.ban,
      };
      localStorage.setItem("InvoiceList", JSON.stringify(invoicesData));
      environment.billingProps = $event.data.BillingPortalProps;
      //console.log(environment.billingProps)
      let azureClientID = ($event.data.BillingPortalProps).aud;
      let accessToken = JSON.parse($event.data.msalKeys).accessToken[0];
     // localStorage.setItem("BillingPortalProps",$event.data.BillingPortalProps);
      localStorage.setItem(`msal.token.keys.${azureClientID}`,$event.data.msalKeys);
      localStorage.setItem(accessToken,$event.data.azureTokenData);
      sessStorage.setItem("apigeeToken-bp",$event.data.apigeeToken);
      //localStorage.setItem("apigeeToken-bp",$event.data.apigeeToken);
    } 
  }

  ngOnInit(): void {
    this.processForm();
  }

  ngAfterViewChecked(): void {
    this.testForm.nativeElement.submit();
    if (this.flag) {
      this.flag = false;
      window.parent.postMessage('FrameLoaded', this.original);
    }

  }


  processForm() {
    console.log("Ban--",this.ban)
    this.url = "https://" + document.location.host + this.callbackComponent;
    var form = document.querySelector('form') || new HTMLFormElement();
    if(this.callbackComponent.includes("payment-processing")){
      form.action = environment.speedpaySSOURL+"&action=Profile";
    }else if(this.callbackComponent.includes("process-recurring")){
      form.action = environment.speedpaySSOURL+"&action=Profile";
    }else{
      form.action = environment.speedpaySSOURL+"&action=NoPayment";
    }
    if (this.checkboxTimestamp)
      form.appendChild(this.createHiddenInput('timestamp', Date.now()));
    if (this.checkboxWalletron)
      form.appendChild(this.createHiddenInput('src', 'walletron'));
    var keyBase64 = this.secretKey;
    const cred = document.getElementById('credentials') || new HTMLElement();
    let array = new Array<String>();
    array.push("sp_credit_account="+this.ban);
    array.push("speedframe_callback_url=" + this.url);
    var str = array.join("|^|");

    var encrypted = CryptoJS.AES.encrypt(str, CryptoJS.enc.Base64.parse(keyBase64), {
      iv: CryptoJS.lib.WordArray.random(16 /* bytes */),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });
    this.postData = CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    this.iv = CryptoJS.enc.Base64.stringify(encrypted.iv);
    return true;
  }

  createHiddenInput(name: any, value: any) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    return input;
  }
}
